import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchContainers({ agro_exporter_process_id, current_page, rows_per_page }) {
    return RequesterV1.get(`agro_exporter/production/basic_container_export/show_process/fetch_containers/${agro_exporter_process_id}?current_page=${current_page}&rows_per_page=${rows_per_page}`)
  },
  fetchExportations({ agro_exporter_process_id, current_page, rows_per_page }) {
    return RequesterV1.get(`agro_exporter/production/basic_container_export/show_process/fetch_exportations/${agro_exporter_process_id}?current_page=${current_page}&rows_per_page=${rows_per_page}`)
  },
  fetchSchedule({ agro_exporter_process_id, year, month }) {
    return RequesterV1.get(`agro_exporter/production/basic_container_export/show_process/${agro_exporter_process_id}/fetch_schedule?year=${year}&month=${month}`);
  },
  downloadExportationsContainersRepXlsx(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/show_process/exportations_containers_rep_xlsx/${agro_exporter_process_id}`,
      { responseType: "blob", foo: 'boo' }
    );
  }

};
